import React, { useState } from "react";
import thumb1 from "assets/img/frontend/thumb1.jpg";
import thumb2 from "assets/img/frontend/thumb2.jpg";
import thumb3 from "assets/img/frontend/thumb3.jpg";

const thumbnails = [thumb1, thumb2, thumb3];

const HotelImage = () => {
  const [mainImage, setMainImage] = useState(thumbnails[0]);

  return (
    <div className="mx-auto mt-6 max-w-screen-2xl rounded-xl bg-white p-6 shadow">
      {/* Header */}
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-3xl font-bold text-gray-800">
            JW Marriott Hotel New Delhi Aerocity
          </h2>
          <div className="mt-1 flex flex-wrap items-center gap-2 text-lg text-gray-500">
            <span>New Delhi, Delhi</span>
            <span className="text-blue-500">•</span>
            <a href="#" className="text-blue-600 hover:underline">
              Location on map
            </a>
            <span className="text-blue-500">•</span>
            <span>3 Km From City</span>
            <span className="text-blue-500">•</span>
            <div className="flex hidden items-center md:block">
              <span className="text-yellow-400">★★★★☆</span>
            </div>
          </div>
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <span className="rounded-md bg-blue-600 px-3 py-1 text-lg font-semibold text-white">
            4.5
          </span>
          <button className="rounded-full bg-blue-600 px-5 py-2 text-lg font-medium text-white shadow-md hover:bg-blue-700">
            Book Now
          </button>
        </div>
      </div>

      {/* Main Image and Thumbnails */}
      <div className="flex flex-col gap-4 lg:flex-row">
        {/* Main Image */}
        <div className="w-full lg:flex-1">
          <img
            src={mainImage}
            alt="Main Room"
            className="aspect-[4/3] max-h-[400px] min-h-[250px] w-full rounded-xl object-cover sm:max-h-[500px] sm:min-h-[300px] lg:max-h-[600px] lg:min-h-[350px]"
            draggable={false}
          />
        </div>

        {/* Thumbnails */}
        <div className="w-full lg:w-[280px]">
          {/* Mobile: Horizontal scroll */}
          <div className="flex gap-3 overflow-x-auto pb-2 lg:hidden">
            {thumbnails.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Thumbnail ${index + 1}`}
                onClick={() => setMainImage(src)}
                className={`h-20 w-32 flex-shrink-0 cursor-pointer rounded-xl object-cover transition-all ${
                  mainImage === src
                    ? "border-4 border-blue-600"
                    : "border-transparent border-4"
                }`}
                draggable={false}
              />
            ))}
          </div>

          {/* Desktop: Vertical stack */}
          <div className="hidden lg:flex lg:flex-col lg:gap-3">
            {thumbnails.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Thumbnail ${index + 1}`}
                onClick={() => setMainImage(src)}
                className={`h-full w-full cursor-pointer rounded-xl object-cover transition-all ${
                  mainImage === src
                    ? "border-4 border-blue-600"
                    : "border-transparent border-4"
                }`}
                draggable={false}
              />
            ))}
          </div>
        </div>

        {/* Mobile rating and book button */}
        <div className="mt-4 flex items-center justify-between gap-3 md:hidden">
          <div className="flex items-center gap-2">
            <span className="rounded-md bg-blue-600 px-3 py-1 text-lg font-semibold text-white">
              4.5
            </span>
            <span className="text-yellow-400">★★★★☆</span>
          </div>

          <button className="rounded-full bg-blue-600 px-5 py-2 text-lg font-medium text-white shadow-md hover:bg-blue-700">
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default HotelImage;
